// extracted by mini-css-extract-plugin
export var smallSpinner = "_wr-0";